import React, { useState } from 'react';
import { Button, IButtonProps } from '@alycecom/ui';
import { Fade } from '@mui/material';
import { useTimeoutFn } from 'react-use';

interface IDelayedButtonProps extends IButtonProps {
  delay: number;
}

const DelayedButton = ({ delay = 1000, children, ...buttonProps }: IDelayedButtonProps): JSX.Element => {
  const [isDisplayed, setIsDisplayed] = useState(false);

  useTimeoutFn(() => {
    setIsDisplayed(true);
  }, delay);

  return (
    <Fade in={isDisplayed}>
      <div>
        <Button {...buttonProps}>{children}</Button>
      </div>
    </Fade>
  );
};

export default DelayedButton;
